import { useWizard } from "react-use-wizard";
import sellSteps from "../sellSteps";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";

interface IKnowPriceStep_6 {}

const KnowPriceStep_6 = ({}: IKnowPriceStep_6) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.knowPrice.step_5);
  };

  const handleNotStep = () => {
    goToStep(sellSteps.knowPrice.step_10);
  };

  const handleYesStep = () => {
    goToStep(sellSteps.knowPrice.step_7);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        yesStep={handleYesStep}
        noStep={handleNotStep}
        yesButtonLabel="Указать самому"
        noButtonLabel="Укажет риелтор"
        text="Параметры продаваемого объекта обсужу с риелтором/укажу сам?"
      />
    </div>
  );
};

export default KnowPriceStep_6;
